
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import { reactLocalStorage } from "reactjs-localstorage"
import toastr from 'toastr'

axios.interceptors.response.use(undefined, function(error) {
    const { response, config } = error
    const newResponse = {}
    const newConfig = {
        url: config.url,
        method: config.method,
        headers: config.headers
    }

    if (config.url != null) {
        newConfig.data = config.data
    }

    if (response != null) {
        if (response.status === 404) {
            return Promise.reject(error)
        }

        if (response.status === 401) {
            toastr.error(`Tu sesión ha expirado`, 'Error')
            window.location.replace('/logout')
        }

        newResponse.status = response.status
        newResponse.statusText = response.statusText
        newResponse.headers = response.headers

        if (response.data != null && response.data.message) {
            newResponse.dataMessage = response.data.message
        }
    }

    return Promise.reject(error)
})

export let baseURL = ''
const hostname = window && window.location && window.location.hostname
const configuredBaseURL = process.env.REACT_APP_API_URL

if (configuredBaseURL) {
    baseURL = configuredBaseURL.replace(/\/$/, '')
} else {
    switch (hostname) {
        case 'localhost':
          baseURL = 'http://localhost'
          break
        default:
          baseURL = 'https://timbrat-api-779786367074.us-central1.run.app'
          break
    }
}

export class ApiHelper {
    getAuthToken() {
        return reactLocalStorage.get('token') ? reactLocalStorage.get('token') : false
    }

    getBaseURL() {
        return baseURL
    }

    getOutgoingHeaders() {
        return {
            'authorization': this.getAuthToken(),
            'request-id': uuidv4(),
            'Request-Source': 'timbrat_ui'
        }
    }

    async getPDFBlob(url, data) {
        try {
            return await axios.post(url, data, {
                baseURL,
                headers: {
                    'authorization': this.getAuthToken(),
                    'request-id': uuidv4(),
                    'Request-Source': 'timbrat_ui',
                    'Accept': 'application/pdf'
                },
                responseType: 'blob'
            })
        } catch (error) {
            throw error
        }
    }

    async postBlob(url) {
        try {
            return await axios.post(url, null, {
                baseURL,
                headers: {
                    'authorization': this.getAuthToken(),
                    'request-id': uuidv4(),
                    'Request-Source': 'timbrat_ui'
                },
                responseType: 'blob'
            })
        } catch (error) {
            throw error
        }
    }

    async post(url, data) {
        try {
            return await axios.post(url, data, {
                baseURL,
                headers: this.getOutgoingHeaders()
            })
        } catch (error) {
            throw error
        }
    }

    async postWithFiles(url, data) {
        let headers = this.getOutgoingHeaders()
        headers = {
            ...headers,
            'Content-Type': 'multipart/form-data'
        }

        try {
            return await axios.post(url, data, {
                baseURL,
                headers
            })
        } catch (error) {
            throw error
        }
    }

    async put(url, data) {
        try {
            return await axios.put(url, data, {
                baseURL,
                headers: this.getOutgoingHeaders()
            })
        } catch (error) {
            throw error
        }
    }

    async patch(url, data) {
        try {
            return await axios.patch(url, data, {
                baseURL,
                headers: this.getOutgoingHeaders()
            })
        } catch (error) {
            throw error
        }
    }

    async patchWithFiles(url, data) {
        let headers = this.getOutgoingHeaders()
        headers = {
            ...headers,
            'Content-Type': 'multipart/form-data'
        }

        try {
            return await axios.patch(url, data, {
                baseURL,
                headers
            })
        } catch (error) {
            throw error
        }
    }

    async get(url) {
        try {
            return await axios.get(url, {
                baseURL,
                headers: this.getOutgoingHeaders()
            })
        } catch (error) {
            throw error
        }
    }

    async delete(url) {
        try {
            return await axios.delete(url, {
                baseURL,
                headers: this.getOutgoingHeaders()
            })
        } catch (error) {
            throw error
        }
    }

    async download(url, uuid, fileType = 'pdf') {
        try {
            let response = await axios.get(url, {
                baseURL,
                headers: ApiHelper.prototype.getOutgoingHeaders(),
                responseType: 'blob'
            })

            let fileName = `${uuid}.${fileType}`
            const disposition = response.headers['content-disposition']
            if (disposition && disposition.indexOf('filename=') !== -1) {
                const match = disposition.match(/filename="?([^";]+)"?/)
                if (match && match[1]) fileName = match[1]
            }

            const urlBlob = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = urlBlob
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            link.parentNode.removeChild(link)
            window.URL.revokeObjectURL(urlBlob)
        } catch (error) {
            // Manejar error blob del backend
            if (error.response && error.response.data instanceof Blob) {
                try {
                    const text = await error.response.data.text()
                    const json = JSON.parse(text)
                    error.response.data = json
                } catch (e) {
                    // No es JSON, dejar el error como está
                }
            }
            throw error
        }
    }
}

export default new ApiHelper()
